const APP_CONFIG = {
  version: "7.93.0",
  title: "Claire V7.93.0",
  version_client: "7.93.0",
};

export default APP_CONFIG;
